export interface ArgGetDeviceInfo {
  govCode: string
  system: string
  deviceId: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgGetDeviceInfo = (arg: any): boolean => {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.system === 'string' &&
    typeof arg.govCode === 'string'
  )
}

export interface ResGetDeviceInfoResult {
  /** デバイスID */
  deviceId?: string
  /** デバイス名 */
  deviceName?: string
  /** 備考 */
  memo?: string
  /** アクセス許可 */
  permissionStatus?: string
  /** アクティベイトした日 */
  addedDateTime?: number
}

export interface ResGetDeviceInfo {
  result: ResGetDeviceInfoResult
}

export interface ArgActivateDeviceInfo {
  govCode: string
  system: string
  activateCode: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgActivateDeviceInfo = (arg: any): boolean => {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.system === 'string' &&
    typeof arg.govCode === 'string' &&
    typeof arg.activateCode === 'string'
  )
}

export interface ResActivateDeviceInfo {
  /** デバイスID */
  deviceId: string
  /** デバイストークン */
  deviceToken: string
}

export interface resActivateDeviceInfo {
  result: ResActivateDeviceInfo
}

export interface ArgUpdateDeviceInfo extends ArgGetDeviceInfo {
  deviceToken: string
  deviceName?: string
  memo?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArgUpdateDeviceInfo = (arg: any): boolean => {
  return (
    arg !== null &&
    typeof arg === 'object' &&
    typeof arg.system === 'string' &&
    typeof arg.govCode === 'string' &&
    typeof arg.deviceToken === 'string' &&
    typeof arg.deviceId === 'string'
  )
}

export interface resUpdateDeviceInfo {
  result: string
}
